import { z } from "zod/v4";

export const DeleteMetafieldRequestBodySchema = z.object({
  ownerId: z.string(),
  namespace: z.string(),
  key: z.string(),
});
export type DeleteMetafieldRequestBodyType = z.infer<
  typeof DeleteMetafieldRequestBodySchema
>;

export const DeleteMetafieldResponseBodySchema = z.string();
export type DeleteMetafieldResponseBodyType = z.infer<
  typeof DeleteMetafieldResponseBodySchema
>;
